"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockBackend = exports.createMockClient = void 0;
const lodash_1 = require("lodash");
/**
 * Creates a mock API client that is used for sagas
 */
const createMockClient = () => {
    let responseResolvers = [];
    const mockReq = (method, useBody) => (pathname, body) => {
        return new Promise((resolve, reject) => {
            const request = { method, pathname, body: undefined };
            if (useBody !== false) {
                request.body = body;
            }
            responseResolvers.push([
                request,
                ({ data, statusCode = 200, expectedRequest }) => {
                    if (statusCode === 200) {
                        // We assert that the request matches the mock response as a sanity check
                        expect(request).toEqual(expectedRequest);
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                },
            ]);
        });
    };
    const mockClient = {
        get: mockReq('get', false),
        del: mockReq('del', false),
        // For backwards compatibility
        delete: mockReq('del'),
        post: mockReq('post'),
        put: mockReq('put'),
        patch: mockReq('patch'),
    };
    const clearRequests = () => {
        responseResolvers = [];
    };
    const getPendingRequests = () => {
        return responseResolvers.map(([request]) => request);
    };
    const mockResponse = (response) => __awaiter(void 0, void 0, void 0, function* () {
        const nextResolverIndex = responseResolvers.findIndex(([request]) => 
        // clone with JSON to remove all undefined props
        (0, lodash_1.isEqual)(JSON.parse(JSON.stringify(request)), JSON.parse(JSON.stringify(Object.assign(Object.assign({}, response.expectedRequest), { 
            // need to trigger hasOwnProp
            body: response.expectedRequest.body })))));
        if (nextResolverIndex === -1) {
            throw new Error(`There are no pending requests that match the expected request: ${JSON.stringify(response.expectedRequest, null, 2)}. Options are: ${JSON.stringify(getPendingRequests(), null, 2)}`);
        }
        const [[_request, nextResolver]] = responseResolvers.splice(nextResolverIndex, 1);
        nextResolver(response);
        // sagas are async, so need to wait for a sec
        yield new Promise((resolve) => setTimeout(resolve, 10));
    });
    const mockResponses = (responses) => __awaiter(void 0, void 0, void 0, function* () {
        for (const response of responses) {
            yield mockResponse(response);
        }
        yield assertNoRequest();
    });
    const assertNoRequest = () => __awaiter(void 0, void 0, void 0, function* () {
        // API requests are async, so we await for a sec so that
        // assertion is part of promise runloop
        yield 1;
        if (responseResolvers.length > 0) {
            throw new Error(`There's another request`);
        }
    });
    return Object.assign(Object.assign({}, mockClient), { getPendingRequests,
        clearRequests,
        mockResponse,
        mockResponses,
        assertNoRequest });
};
exports.createMockClient = createMockClient;
/**
 * @deprecated we should use createMockClient instead
 */
const createMockBackend = () => {
    const client = (0, exports.createMockClient)();
    return Object.assign(Object.assign({}, client), { get(uri, _config) {
            return client.get(uri);
        },
        delete(uri, _config) {
            return client.del(uri);
        },
        put(uri, data) {
            return client.put(uri, data);
        },
        post(uri, data) {
            return client.post(uri, data);
        },
        patch(uri, data) {
            return client.patch(uri, data);
        } });
};
exports.createMockBackend = createMockBackend;
//# sourceMappingURL=mock-client.js.map